/* ============================================================
   sd-type.js — word split + staggered variable-axis reveal
   Recurses into child spans (.sd-raised etc). Single read→write pass.

   Uses data-sd-typed (NOT data-sd-in): sd-motion.css treats
   [data-sd-in] as "hide until .sd-vis", so sharing that name made
   headings vanish depending on which script finished first.
   ============================================================ */
(function () {
  'use strict';

  var SELECTOR = [
    '[data-sd-type]',
    '.sd-hero__copy h1',
    '.sd-tiers h2', '.sd-tiers h3',
    '.sd-faq h2', '.sd-brand h2', '.sd-countdown h2'
  ].join(',');

  var STAGGER = 58;
  var DURATION = 620;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function wrapTextNodes(node, counter) {
    var kids = Array.prototype.slice.call(node.childNodes);

    kids.forEach(function (child) {
      if (child.nodeType === Node.ELEMENT_NODE) {
        if (!child.classList.contains('sd-word')) wrapTextNodes(child, counter);
        return;
      }
      if (child.nodeType !== Node.TEXT_NODE) return;

      var frag = document.createDocumentFragment();

      child.textContent.split(/(\s+)/).forEach(function (chunk) {
        if (!chunk) return;
        if (!chunk.trim()) { frag.appendChild(document.createTextNode(' ')); return; }

        var outer = document.createElement('span');
        outer.className = 'sd-word';

        var inner = document.createElement('span');
        inner.className = 'sd-word__i';
        inner.style.transitionDelay = (counter.n * STAGGER) + 'ms';
        inner.textContent = chunk;

        outer.appendChild(inner);
        frag.appendChild(outer);
        counter.n++;
      });

      node.replaceChild(frag, child);
    });
  }

  function split(el) {
    if (el.dataset.sdSplit) return;
    var counter = { n: 0 };
    wrapTextNodes(el, counter);
    el.dataset.sdSplit = '1';
    el.dataset.sdCount = String(counter.n || 1);
  }

  function init() {
    var els = Array.prototype.slice.call(document.querySelectorAll(SELECTOR))
      .filter(function (el) {
        return !el.closest('[data-sd-still]') && !el.dataset.sdSplit;
      });
    if (!els.length) return;

    if (reduced.matches || !('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.setAttribute('data-sd-typed', '');
        el.setAttribute('data-sd-done', '');
      });
      return;
    }

    els.forEach(split);

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        el.setAttribute('data-sd-typed', '');
        var total = DURATION + (parseInt(el.dataset.sdCount, 10) * STAGGER) + 80;
        setTimeout(function () { el.setAttribute('data-sd-done', ''); }, total);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });

    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else { init(); }

  document.addEventListener('shopify:section:load', init);
})();